import { render, staticRenderFns } from "./EditStandardisedJob.vue?vue&type=template&id=7bec1de4&scoped=true&"
import script from "./EditStandardisedJob.vue?vue&type=script&lang=ts&"
export * from "./EditStandardisedJob.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bec1de4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
